var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",class:{'in-transition':_vm.inTransition},attrs:{"data-page":""}},[_c('transition',{attrs:{"name":"page"},on:{"enter":_vm.mainRouterEnter,"beforeEnter":_vm.mainRouterBeforeEnter}},[_c('router-view',{staticClass:"page__main main"})],1),_vm._v(" "),_c('page-footer',{staticClass:"page__footer"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a6f777a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/partials/AppPage.vue
// module id = null
// module chunks = 